module.exports = __webpack_public_path__ + "img/SK31320155.5ebfbdb2.png";